// extracted by mini-css-extract-plugin
module.exports = {"policyLinkContainer":"PoliciesTable_policyLinkContainer__28-X7","currencyContainer":"PoliciesTable_currencyContainer__1J0zt"};